export default __webpack_public_path__ + "static/media/tiktok-shop.e69933bd.svg";